import apiInternal from '@services/axios-internal';

export const apiVerifyCodeForGift = async (
  // eventId: string,
  code: string,
): Promise<boolean> => apiInternal.post('/api/gift', { code });
